var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#E7F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6666 51.4997L56.6666 58.4997C56.6666 64.333 54.3333 66.6663 48.4999 66.6663L41.4999 66.6663C35.6666 66.6663 33.3333 64.333 33.3333 58.4997L33.3333 51.4997C33.3333 45.6663 35.6666 43.333 41.4999 43.333L48.4999 43.333C54.3333 43.333 56.6666 45.6663 56.6666 51.4997Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 41.4997L66.6666 48.4997C66.6666 54.333 64.3333 56.6663 58.4999 56.6663L56.6666 56.6663L56.6666 51.4997C56.6666 45.6663 54.3333 43.333 48.4999 43.333L43.3333 43.333L43.3333 41.4997C43.3333 35.6663 45.6666 33.333 51.4999 33.333L58.4999 33.333C64.3333 33.333 66.6666 35.6663 66.6666 41.4997Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCopy);
export default __webpack_public_path__ + "static/media/modal_copy.6bfd605491bf33a217d10971906b4a66.svg";
export { ForwardRef as ReactComponent };